import Spacer from "@/components/atoms/spacer"
import ResponsiveTitle from "@/components/molecules/responsiveTitle"
import Container from "@/components/templates/container"
import Founders from "./founders"
import Teams from "./teams"

const OurTeam = ({
    founders,
    teams,
}) => {
  const base = 'relative w-full mt-mediumDesktop lg:mt-largeDesktop'

  return (
    <Container outerClassName="mt-mediumDesktop lg:mt-largeDesktop">
      <Spacer />
      <div className={base}>
        <ResponsiveTitle left="OUR" right="TEAM" />
        <Founders founders={founders} />
        <Teams teams={teams} />
      </div>
    </Container>
  )
}

export default OurTeam
